import React, { useState, useEffect } from 'react';
import SubHeader from "../components/SubHeader";
import headerImg from '../images/Stepper1.png';  
import stepper from '../hybridImages/Stepper1.png';
import pStepper from '../hybridImages/PStepper1.png';  
import comdetailsdata from '../data/comdetailsdata.json';
import { useHistory } from "react-router-dom";
import FormContainer from '../components/FormContainer';
import {  Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import { FormInput, CusFormInput, CusFormLabel, FormTitle, CusFormInput2, FormTitleTooltip } from '../validation/Form-Components';
import config from '../appconfig/config.json';
import myInfoCountries from '../data/myInfoCountryList.json';
import helper from '../factory/Helper';
import CusRadioButton from "../components/CusRadioButton";
import service from '../services/CompDtlsApiService';
import {blockValidator, streetValidator, levelValidator, unitNoValidator, buildingValidator, postalCodeValidator,requiredValidator, alphaNumValidator, winDeliValidator, addressValidator, postOfficeValidator, lockBagValidator, storeyValidator, godownValidator, lotMukimValidator, boxNoValidator, houseNoValidator, numericValidator, annualRevenueValidator, profitLossValidator} from '../validation/Validators';
import Loading from '../components/Loading';
import { Button } from '@progress/kendo-react-buttons';
import FinancialHighlights from '../components/FinancialHighlights';
import addService from '../services/ApiService';
import CusToast from '../components/CusToast';
import storage from '../factory/StorageFactory';
import Popup from '../components/CusPopup';
import { Checkbox, Input, NumericTextBox } from '@progress/kendo-react-inputs';
import LoadingText from '../components/LoadingText';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { DateInput,DatePicker } from '@progress/kendo-react-dateinputs';
import { Error } from '@progress/kendo-react-labels';
import CusNotification from '../components/CusNotification';
import BlueboxIconTxt from '../hybridcomponents/BlueboxIconTxt';
import mData from '../hybriddata/mainform.json';
import EnterpriseDeclarePopup from '../hybridcomponents/EnterpriseDeclarePopup';
import FormHeader from '../components/FormHeader';
import { ColumnMenuFilterLogic } from '@progress/kendo-react-data-tools';


const CompanyDetails = (props) => {
    
    
    let timer; 
    const history = useHistory();

    const numericRegex = new RegExp(/^[0-9]+$/);
    // const annualRevenueRegex = new RegExp(/^[0-9.]+$/);
    const annualRevenueRegex = new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/);
    // const profitLossRegex = new RegExp(/^[0-9.-]+$/);
    const profitLossRegex = new RegExp(/^-?[0-9]\d*(\.[0-9]{0,2})?$/);

    const [selectedValue, setSelectedValue] = useState('Y');  //rdo button default to Y
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isLoading, setIsLoading] = useState(true); //default true
    const [isSearching,setIsSearching] = useState(false);
    const [isSaving,setIsSaving] = useState(false);

    const [showEnterpriseDeclarePopup,setShowEnterpriseDeclarePopup] = useState(false);

    const [mailAddType, setMailAddType] = useState(config.addTypeLocal);
    const [financialHighlights,setFinancialHighlights] = useState({});

    const [showAddBtn, setShowAddBtn] = useState(true);  //default true

    const [latestYrEndDate, setLatestYrEndDate] = useState();
    const [previousYrEndDate, setPreviousYrEndDate] = useState();
    const [annualRevenue1, setAnnualRevenue1] = useState(null);
    const [profitLostBeforeTax1, setProfitLostBeforeTax1] = useState(null);
    const [annualRevenue2, setAnnualRevenue2] = useState(null);
    const [profitLostBeforeTax2, setProfitLostBeforeTax2] = useState(null);
    const [isPrevFinanceFieldsMandatory,setIsPrevFinanceFieldsMandatory] = useState(false);

    const min = new Date('2020-12-01');


    // CR start dec 2022

    let yearminus2=new Date().getFullYear() - 2;
    let yearminus2month=new Date().getMonth();
    
    const minDateRange = new Date(new Date().setFullYear(yearminus2, yearminus2month-1 , 30));

    const maxDateRange = new Date();

    const [previousMaxDate, setpreviousMaxDate] = React.useState();
    const [previousMinDate, setpreviousMinDate] = React.useState();

    const [flagSucessL, setflagSucessL] = React.useState(false);
    const [flagStatusP, setflagSucessP] = React.useState(false);
   
    const [isLocalLandedhouse,setisLocalLandedhouse] = useState(false);

    //CR end 
    const showWCLDeclare = () => {
        let isWCL = storage.getIsProductWCL();
        if(isWCL !== undefined) {
            if(isWCL === 'true') {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    
    const [buttonPopup, setButtonPopup] = useState(showWCLDeclare());
    const [isChecked, setIsChecked] = useState(false);
    
    const initialResponseState = {
        CompDtls:{
            Company_UEN: "",
            Company_Name: "",
            Entity_Type_Code:"",
            Entity_Type_Desc: "",
            Registration_Date: "",
            Country_of_Incorporation_Desc: "",
            country_of_incorporation_Code:"",
            business_constitution_Code:"",
            business_constitution_Desc:"",
            Entity_Status:"",
            Primary_Activity_Code:"",
            Primary_Activity_Desc:"",
            Secondary_Activity_Code:"", 
            Secondary_Activity_Desc:"",
            Business_Expiry_Date:"",
            Address_Type_Code:"",
            Address_Type_Desc:"",
            Ownership_Code:"",
            Ownership_Desc:"",
            Captial_Type_Code:"",
            Captial_Type_Desc:"",
            Capital_PaidupAmount:"",
            Capital_IssuedAmount:"",
            Captial_ShareAllotedAmount:"",
            Capital_Currency_Code:"",
            Capital_Currency_Desc:"",
            Reg_Add_Block_No: "",
            Reg_Add_Street_Name: "",
            Reg_Add_Floor_No: "",
            Reg_Add_Unit_No: "1",
            Reg_Add_Bldg_Name: "",
            Reg_Add_Postal_Code: "",
            Reg_Add_Country_Code: "",
            Reg_Add_Country_Desc: "",
            Address_Line_1: null,
            Address_Line_2: null
        },
        RegBizMailAddr: {
            isMailAddressSameAsRegisterAddress: '',
            Address_Format_Type: "",
            Block_Number: "",
            Street_Name: "",
            Storey_Number: "",
            Unit_Number: "",
            Building_Name: "",
            Godown_Number: "",
            Lot_Mukim_Number:"",
            Box_Number: "",
            Locked_Bag_Number: "",
            Post_Office_Name: "",
            House_Number: "",
            Window_Delivery_Number: "",
            Address_Line1:"",
            Address_Line2 :"",
            Address_Line3 :"",
            State_City:"",
            Country: "",
            Country_Desc: "",
            Postal_Code: ""
        },
        financialHighlights:[],
        ApplicantsDtlsMyInfo:{},
        Holdersdetails:[],
    };

    const [response, setResponse] = useState(initialResponseState);

    const [mailingAddress, setMailingAddress] = useState({
        isMailAddressSameAsRegisterAddress: '',
        address_Format_Type: "",
        block_Number: "",
        street_Name: "",
        storey_Number: "",
        unit_Number: "",
        building_Name: "",
        postal_Code: "",
        country: "",
        country_Desc: "",
        address_Line1:"",
        address_Line2 :"",
        address_Line3 :"",
        state_City:"",
        locked_Bag_Number: "",
        godown_Number: "",
        lot_Mukim_Number:"",
        box_Number: "",
        post_Office_Name: "",
        house_Number: "",
        window_Delivery_Number: ""
    });

  
    useEffect(() => {
        // console.log('@CompanyDetails useEffect');
 
        // window.addEventListener('beforeunload', alertUser)
        // window.addEventListener('unload', handleEndConcert)

        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
  
        window.scrollTo(0,0);
        getData();
 
        return () => {
            clearTimeout(timer);
            // window.removeEventListener('beforeunload', alertUser)
            // window.removeEventListener('unload', handleEndConcert)
        }
    }, []);

 
    const handleChange = React.useCallback(
        (e) => {
            setMailAddType(null);
            setSelectedValue(e.value);
            setMailingAddress({
                isMailAddressSameAsRegisterAddress: '',
                address_Format_Type:'',
                block_Number:'',
                street_Name:'',
                storey_Number:'',
                unit_Number:'',
                building_Name:'',
                postal_Code:'',
                country: comdetailsdata.defCountry.value,
                country_Desc: comdetailsdata.defCountry.label,
                address_Line1:'',
                address_Line2 :'',
                address_Line3 :'',
                state_City:'',
                locked_Bag_Number:'',
                godown_Number:'',
                lot_Mukim_Number:'',
                box_Number:'',
                post_Office_Name:'',
                house_Number:'',
                window_Delivery_Number:''
             
            })
        },
        [setSelectedValue]
    );
       
    const handleSubmit = (dataItem) => {
       
        dataItem.event.preventDefault();
      
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.BacktoHome;
            return;
        }

        if(isValidFinicalHightLights()===false) {
            return;
        }

        if(dataItem.isValid) {
            
            let data = JSON.parse(JSON.stringify(dataItem.values));
     
           saveCompanyDetails(formatJsonParams(data));
        }
    }

    const isValidFinicalHightLights = () => {
        let isValid = true;
        // console.log('isValidFinicalHightLights')
        if(latestYrEndDate === '' || latestYrEndDate === null || latestYrEndDate === undefined) {
            showErrMsg(comdetailsdata.errMsg.invalidLatestYrEnd);
            isValid = false;
        }

        else if(annualRevenue1 === '' || annualRevenue1 === null || annualRevenue1 === undefined) {
            showErrMsg(comdetailsdata.errMsg.emptyAnnualRevenue);
            isValid = false;
        }
        else if(profitLostBeforeTax1 === '' || profitLostBeforeTax1 === null || profitLostBeforeTax1 === undefined) {
            showErrMsg(comdetailsdata.errMsg.emptyProfitLoss);
            isValid = false;
        }
        else if(showAddBtn === false && isFProductBTL(response)) {
   
            if(previousYrEndDate === '' || previousYrEndDate === null || previousYrEndDate === undefined) {
                showErrMsg(comdetailsdata.errMsg.invalidPrevYrEnd);
                isValid = false;
             }
            else if(annualRevenue2 === '' || annualRevenue2 === null || annualRevenue2 === undefined ) {
                showErrMsg(comdetailsdata.errMsg.emptyAnnualRevenue);
                isValid = false;
            }
            else if(profitLostBeforeTax2 === '' || profitLostBeforeTax2 === null || profitLostBeforeTax2 === undefined ) {
                showErrMsg(comdetailsdata.errMsg.emptyProfitLoss)
                isValid = false;
            }
        }

        return isValid;
    }

    const handleChkChange = (e) => {
        setIsChecked(e.value);
    }

    const saveCompanyDetails = (params) => {
        
       if(selectedValue === null || selectedValue === undefined ) {
            showErrMsg(config.error.RdoOption+'\n(Mailing address is the same as the registered business address)');
            return;
       }

       if(selectedValue === 'N') {
        if(mailAddType === null) {
            getAddressbyPostalCode(params.Postal_Code);
            return;
        } 
       }
       
        if(!isValidMyInfoFields(response)) {
            showErrMsg(config.error.MyInfo.MissingData);
            return;
        }

        setIsSaving(true);
        service.post(params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }          
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const formatJsonParams = (data) => {

        let latYrEndDate = formatDate(latestYrEndDate);
        let prevYrEndDate = previousYrEndDate?formatDate(previousYrEndDate):'';

        // console.log('@formatJsonParams: ',profitLostBeforeTax2?profitLostBeforeTax2:'')
 
        let params;
        if(selectedValue === 'Y'){
            params= {
                stateId: storage.getStateId(),
                referenceNo: storage.getRefNo(),
                isMailAddressSameAsRegisterAddress: selectedValue,
                Address_Format_Type: "",
                Block_Number: "",
                Street_Name: "",
                Storey_Number: "",
                Unit_Number: "",
                Building_Name: "",
                Postal_Code: "",
                Country: "",
                Country_Desc: "",
                Address_Line1:"",
                Address_Line2 :"",
                Address_Line3 :"",
                State_City:"",
                Locked_Bag_Number: "",
                Godown_Number: "",
                Lot_Mukim_Number:"",
                Box_Number: "",
                Post_Office_Name: "",
                House_Number: "",
                Window_Delivery_Number: "",
                LatestFinancialYearEndDate: latYrEndDate,
                AnnualRevenue1: annualRevenue1,
                ProfitOrLossBeforeTax1: profitLostBeforeTax1,
                PreviousFinancialYearEndDate: prevYrEndDate,
                AnnualRevenue2: annualRevenue2?annualRevenue2:'' ,
                ProfitOrLossBeforeTax2: profitLostBeforeTax2
            }
        }
        else{ 
            params = {
                stateId: storage.getStateId(),
                referenceNo: storage.getRefNo(),
                isMailAddressSameAsRegisterAddress: selectedValue,
                Address_Format_Type: mailAddType,
                Block_Number: data.block_Number,
                Street_Name: data.street_Name,
                Storey_Number: data.storey_Number,
                Unit_Number: data.unit_Number,
                Building_Name: data.building_Name,
                Postal_Code: data.postal_Code,
                Country: data.country,
                Country_Desc: data.country_Desc,
                Address_Line1:data.address_Line1,
                Address_Line2 :data.address_Line2,
                Address_Line3 :data.address_Line3,
                State_City:data.state_City?data.state_City:comdetailsdata.defCountry.label,
                Locked_Bag_Number: data.locked_Bag_Number,
                Godown_Number: data.godown_Number,
                Lot_Mukim_Number:data.lot_Mukim_Number,
                Box_Number: data.box_Number,
                Post_Office_Name: data.post_Office_Name,
                House_Number: data.house_Number,
                Window_Delivery_Number: data.window_Delivery_Number,
                LatestFinancialYearEndDate: latYrEndDate,
                AnnualRevenue1: annualRevenue1,
                ProfitOrLossBeforeTax1: profitLostBeforeTax1,
                PreviousFinancialYearEndDate: prevYrEndDate,
                AnnualRevenue2: annualRevenue2?annualRevenue2:'' ,
                ProfitOrLossBeforeTax2: profitLostBeforeTax2?profitLostBeforeTax2:''
            }
        }
   
        return params;
    }

    const isValidMyInfoFields = (resObj) => {
  
        let isValid = true;
        if(resObj.CompDtls.Company_UEN === null|| resObj.CompDtls.Company_UEN === "" || resObj.CompDtls.Company_UEN === undefined) {
            // console.log('UEN not found')
            isValid = false;
        }
        else if(resObj.CompDtls.Company_Name === null|| resObj.CompDtls.Company_Name === "" || resObj.CompDtls.Company_Name === undefined) {
            // console.log('Company_Name not found')
            isValid = false;
        }
        else if(resObj.CompDtls.Registration_Date === null|| resObj.CompDtls.Registration_Date === "" || resObj.CompDtls.Registration_Date === undefined) {
            // console.log('Registration_Date not found')
            isValid = false;
        }
        else if(resObj.CompDtls.country_of_incorporation_Code === null|| resObj.CompDtls.country_of_incorporation_Code === "" || resObj.CompDtls.country_of_incorporation_Code === undefined) {
            // console.log('country_of_incorporation_Code not found')
            isValid = false;
        }
        // 27 Nov 2022, upon Ish confirmation, this is not mandatory field in PIV
        // else if(resObj.CompDtls.Business_Expiry_Date === null|| resObj.CompDtls.Business_Expiry_Date === "" || resObj.CompDtls.Business_Expiry_Date === undefined) {
        //     isValid = false;
        // }
        else if(resObj.CompDtls.Primary_Activity_Desc === null|| resObj.CompDtls.Primary_Activity_Desc === "" || resObj.CompDtls.Primary_Activity_Desc === undefined) {
            // console.log('Primary_Activity_Desc not found')
            isValid = false;
        }
        else if(resObj.CompDtls.Address_Type_Code === null|| resObj.CompDtls.Address_Type_Code === "" || resObj.CompDtls.Address_Type_Code === undefined) {
            // console.log('Address_Type_Code not null')
            isValid = false;
        }
        else if(resObj.CompDtls.Address_Type_Code === config.addTypeLocal) {
            if(resObj.CompDtls.Reg_Add_Postal_Code === null || resObj.CompDtls.Reg_Add_Postal_Code === "" || resObj.CompDtls.Reg_Add_Postal_Code === undefined) {
                // console.log('Reg_Add_Postal_Code not found')
                isValid = false;
            }
            else if(isLocalLandedhouse){
                if(resObj.CompDtls.Reg_Add_Block_No === null || resObj.CompDtls.Reg_Add_Block_No === "" || resObj.CompDtls.Reg_Add_Block_No === undefined){
                // console.log('Reg_Add_Block_No not found')
                isValid = false;
            }
            }
            else if(resObj.CompDtls.Reg_Add_Street_Name === null || resObj.CompDtls.Reg_Add_Street_Name === "" || resObj.CompDtls.Reg_Add_Street_Name === undefined) {
                // console.log('Reg_Add_Street_Name not found')
                isValid = false;
            }
        }
        else if(resObj.CompDtls.Address_Type_Code === config.addTypeForeign) {
            if(resObj.CompDtls.Address_Line_1 === null || resObj.CompDtls.Address_Line_1 === "" || resObj.CompDtls.Address_Line_1 === undefined) {
                isValid = false;
            }
            else if(resObj.CompDtls.Address_Line_2 === null || resObj.CompDtls.Address_Line_2  === "" || resObj.CompDtls.Address_Line_2  === undefined){
                isValid = false;
            }
        }
        // 27 Nov 22 Ish asked to remove after PIV
        // else if(resObj.CompDtls.Capital_IssuedAmount === null || resObj.CompDtls.Capital_IssuedAmount === "" || resObj.CompDtls.Capital_IssuedAmount === undefined) {
        //     isValid = false
        // }
        // else if(resObj.CompDtls.Business_Former_Name === null || resObj.CompDtls.Business_Former_Name === "" || resObj.CompDtls.Business_Former_Name === undefined) {
        //     console.log('Business_Former_Name')
        //     isValid = false
        // }
       

        return isValid;
    }


    const getAndSetStateId = () => {  // get State Id from query string and store in localhost
    
        const queryString = require('query-string');
        const parsed = queryString.parse(props.location.search);
        let stateId = parsed.state;
        storage.setStateId(stateId);
    }

    const getData = () => {
 
        getAndSetStateId();
        service.get().then( res =>{
            setIsLoading(false);
            if(res.data.isSucess) {
                
                if(res.data.model.fields.Data === "Empty") {  //MyInfo user click close, route to Product page.
                    goToErrorPage(config.ErrType.EmptyAPDtls);
                    return;
                }
             
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
                checkIsProductGAS(res.data.model.fields.request);
                checkIsProductPureAIP(res.data.model.fields.request);
                //test
                // console.log('getLastSixMonths: ',getLastSixMonths());
            }
            else {
                showErrMsg(config.error.GetApiFailed);
            }
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

   
    const checkIsProductGAS = (data) => {
        let result = false;
        if(storage.getAppStage() === config.AppStage.APPRESUME) {
            if(data.Request_Form.GAS === 'Y') {
                result = true;
            }
        }

        setShowEnterpriseDeclarePopup(result);
        
    }

    const checkIsProductPureAIP = (data) => {
        let result = false;
        if(data.Request_Form.FinancingProduct === config.bizFinancing.AIP) { //AIP
            //AIPOTP==N && NonSole && DOIncorp>1Yr && validAIPSSIC 
            if(data.Request_Form.IsExistingOTPAvailable === 'N' && 
                data.CompDtls.SoleorNonSole === config.bizConst.NonSole &&
                (helper.isDateMorethanOneYrAgo(data.CompDtls.Registration_Date) === true) &&
                (isValidSSICForAIP(data) === true)) {
                    result = true;
            }
            else {
                result = false;
            }
        }
        // console.log('checkIsProductPureAIP', result);
        storage.setIsPureAIP(result);
    }

    const isValidSSICForAIP = (data) => {
        let isValid = false;
        const primarySSIC = data.CompDtls.Primary_Activity_Code;
        const secondarySSIC = data.CompDtls.Secondary_Activity_Code;
        if(primarySSIC !== null) {
            if(primarySSIC === '64202') { 
                isValid = false;
            }
            else { 
                isValid = true;
            }
        }
        else if(secondarySSIC !== null) {
            if(primarySSIC === '64202') { 
                isValid = false;
            }
            else { 
                isValid = true;
            }
        }
        return isValid;
    }

    const bindFormData = (data) => {
        try{
            storage.setRefNo(data.RefNum);
            storage.setBizConstStatus(data.CompDtls.SoleorNonSole);
            //for localPoperty Reg block validation 
            checkAdressforLandedProperty(data.CompDtls.Reg_Add_Postal_Code);
            checkDateOfIncorpMonths(data.CompDtls.Registration_Date);

            if(data.financialHighlights !== undefined ||data.financialHighlights !== null ) {
              bindFinancialHighlights(data);
            }

            if(data.RegBizMailAddr === null) { // first time
                setSelectedValue('Y');
            }
            else if(data.RegBizMailAddr.isMailAddressSameAsRegisterAddress === 'Y') { 

                setSelectedValue(data.RegBizMailAddr.isMailAddressSameAsRegisterAddress);
            
                setMailingAddress({
                    isMailAddressSameAsRegisterAddress: '',
                    address_Format_Type: "",
                    block_Number: "",
                    street_Name: "",
                    storey_Number: "",
                    unit_Number: "",
                    building_Name: "",
                    postal_Code: "",
                    country: "",
                    country_Desc: "",
                    address_Line1:"",
                    address_Line2 :"",
                    address_Line3 :"",
                    state_City:"",
                    locked_Bag_Number: "",
                    godown_Number: "",
                    lot_Mukim_Number:"",
                    box_Number: "",
                    post_Office_Name: "",
                    house_Number: "",
                    window_Delivery_Number: ""
                })
            }   
            else {  //isMailAddressSameAsRegisterAddress === N
                setSelectedValue(data.RegBizMailAddr.isMailAddressSameAsRegisterAddress);
                setMailAddType(data.RegBizMailAddr.Address_Format_Type);
                setMailingAddress({
                    isMailAddressSameAsRegisterAddress: data.RegBizMailAddr.isMailAddressSameAsRegisterAddress !== null?data.RegBizMailAddr.isMailAddressSameAsRegisterAddress:'',
                    address_Format_Type: data.RegBizMailAddr.Address_Format_Type !== null? data.RegBizMailAddr.Address_Format_Type:'',
                    block_Number: data.RegBizMailAddr.Block_Number !== null? data.RegBizMailAddr.Block_Number:'',
                    street_Name: data.RegBizMailAddr.Street_Name !==null? data.RegBizMailAddr.Street_Name:'',
                    storey_Number: data.RegBizMailAddr.Storey_Number !==null?data.RegBizMailAddr.Storey_Number:'',
                    unit_Number: data.RegBizMailAddr.Unit_Number !== null?data.RegBizMailAddr.Unit_Number:'' ,
                    building_Name: data.RegBizMailAddr.Building_Name !== null?data.RegBizMailAddr.Building_Name:'',
                    postal_Code: data.RegBizMailAddr.Postal_Code !== null? data.RegBizMailAddr.Postal_Code:'',
                    country: data.RegBizMailAddr.Country !== null || data.RegBizMailAddr.Country !== ''? data.RegBizMailAddr.Country:'SG',
                    country_Desc: data.RegBizMailAddr.Country_Desc !== null || data.RegBizMailAddr.Country_Desc !== ''? data.RegBizMailAddr.Country_Desc:'SINGAPORE',
                    address_Line1:data.RegBizMailAddr.Address_Line1 !== null? data.RegBizMailAddr.Address_Line1:'',
                    address_Line2 :data.RegBizMailAddr.Address_Line2 !== null? data.RegBizMailAddr.Address_Line2:'',
                    address_Line3 :data.RegBizMailAddr.Address_Line3 !== null? data.RegBizMailAddr.Address_Line3:'',
                    state_City:data.RegBizMailAddr.State_City !== null? data.RegBizMailAddr.State_City:'',
                    locked_Bag_Number: data.RegBizMailAddr.Locked_Bag_Number !== null? data.RegBizMailAddr.Locked_Bag_Number:'',
                    godown_Number: data.RegBizMailAddr.Godown_Number !== null? data.RegBizMailAddr.Godown_Number:'',
                    lot_Mukim_Number:data.RegBizMailAddr.Lot_Mukim_Number !== null? data.RegBizMailAddr.Lot_Mukim_Number:'',
                    box_Number: data.RegBizMailAddr.Box_Number !== null? data.RegBizMailAddr.Box_Number:'',
                    post_Office_Name: data.RegBizMailAddr.Post_Office_Name !== null? data.RegBizMailAddr.Post_Office_Name:'',
                    house_Number: data.RegBizMailAddr.House_Number !== null? data.RegBizMailAddr.House_Number:'',
                    window_Delivery_Number: data.RegBizMailAddr.Window_Delivery_Number !== null? data.RegBizMailAddr.Window_Delivery_Number:''
                })
            }
        }
        catch(e) {

        }
    }

    const bindFinancialHighlights = (data) => {
        if(data.financialHighlights.LatestFinancialYearEndDate === '' ||data.financialHighlights.LatestFinancialYearEndDate===null ||data.financialHighlights.LatestFinancialYearEndDate === undefined) {
            setLatestYrEndDate();
        }
        else {
           
            setLatestYrEndDate(new Date(data.financialHighlights.LatestFinancialYearEndDate))
            let yearminus1=new Date(data.financialHighlights.LatestFinancialYearEndDate).getFullYear() - 1;
            let setMinDateValue= new Date(new Date(data.financialHighlights.LatestFinancialYearEndDate).setFullYear(yearminus1, 0, 1));
            let setMaxDateValue =new Date(new Date(data.financialHighlights.LatestFinancialYearEndDate).setFullYear(yearminus1, 11, 31));//dec
       
            setpreviousMaxDate(setMaxDateValue);
            setpreviousMinDate(setMinDateValue);
        }
        if(data.financialHighlights.PreviousFinancialYearEndDate === ''|| data.financialHighlights.PreviousFinancialYearEndDate===null || data.financialHighlights.PreviousFinancialYearEndDate === undefined) {
            setPreviousYrEndDate();
        }
        else {
            setPreviousYrEndDate(new Date(data.financialHighlights.PreviousFinancialYearEndDate));
            setShowAddBtn(false);
        }
       
        if(data.financialHighlights.AnnualRevenue1 === '') {
            setAnnualRevenue1(null);
        }
        else {
            setAnnualRevenue1(parseFloat(data.financialHighlights.AnnualRevenue1))
        }

        if(data.financialHighlights.ProfitOrLossBeforeTax1 === '') {
            setProfitLostBeforeTax1(null);
        }
        else {
            setProfitLostBeforeTax1(parseFloat(data.financialHighlights.ProfitOrLossBeforeTax1))
        }

        if(data.financialHighlights.AnnualRevenue2 === '' || data.financialHighlights.PreviousFinancialYearEndDate===null) {
            setAnnualRevenue2(null);
        }
        else {
            setAnnualRevenue2(parseFloat(data.financialHighlights.AnnualRevenue2))
        }

        if(data.financialHighlights.ProfitOrLossBeforeTax2 === '' || data.financialHighlights.PreviousFinancialYearEndDate===null) {
            setProfitLostBeforeTax2(null);
        }
        else {
            setProfitLostBeforeTax2(parseFloat(data.financialHighlights.ProfitOrLossBeforeTax2))
        }
    }

    const isDateOfIncorpLessThanOneYr = (dateIncorp) => {
      
        let result = false;
        const today = new Date();
        const date2 = new Date(dateIncorp)
        const difference = differenceInMonths(today, date2);
 
        if(difference <= 12) {
            result = true; 
        }
        else {
            result = false;
        }
        return result;
    }

    const isDateOfIncorpLessThanTwoYrs = (dateIncorp) => {
        let result = false;
        const today = new Date();
        const date2 = new Date(dateIncorp)
        const difference = differenceInMonths(today, date2);
        if(difference < 24) {
            result = true; 
        }
        else {
            result = false;
        }
   
        return result;
    }


    const checkDateOfIncorpMonths = (dateIncorp) => { //check date of incorpation is within 24 months, CR SME efinancing financial logic v1.2.doc 
        if(dateIncorp !== null) {
            if(isDateOfIncorpLessThanTwoYrs(dateIncorp)) {
                setIsPrevFinanceFieldsMandatory(false);
                setShowAddBtn(true);
            }
            else {
                setIsPrevFinanceFieldsMandatory(true);
                setShowAddBtn(false);
            } 
        }
        else {
            setIsPrevFinanceFieldsMandatory(false); //default to false
            setShowAddBtn(true);
        }
    }

    const differenceInMonths = (date1, date2) => {
        const monthDiff = date1.getMonth() - date2.getMonth();
        const yearDiff = date1.getYear() - date2.getYear();
 
        // console.log('monthDiff ',monthDiff);
        // console.log('yearDiff ',yearDiff);
        // console.log('differenceInMonths ',monthDiff + yearDiff * 12);
 
        return monthDiff + yearDiff * 12;
    }
 
    
 


    const createFinancialHightlights = (data) => {
        let temp = [], min=[], max = [];
        if(!Array.isArray(data.financialHighlights)) {
            temp.push(data.financialHighlights);
        }
        else {
            temp = data.financialHighlights;
        }

        for (let i in temp) {
            max.push(temp[i]);
            if(i < 2) min.push(temp[i]);
        }
        
        setFinancialHighlights({
            minData:min,
            maxData:max
        });
    }
  

    const goToErrorPage = (errType) => {
        props.history.push(config.route.InvalidEntity,{errType:errType});
   }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
  
const checkAdressforLandedProperty=(PostalLanded)=>{
    addService.getAddress(PostalLanded).then(res=>{
        // console.log('checkAdressforLandedProperty: ',res)
        let data= res.data.model;
        let resdata = data[0];
  
        if(resdata.addR_FMT_CODE === 'S'){
            setisLocalLandedhouse(false);
        }else{
            setisLocalLandedhouse(true)
        }
    });
}
    const getAddressbyPostalCode = (postalCode) => {
  
        addService.getAddress(postalCode).then(res=>{

            setIsSearching(false);
            let data= res.data.model;
            let resdata = data[0]
           
            let addTypeCode, blkno='', building='', street='', stCityName = '',poBox ='',unitNo='',storeyNo='';
            let postOfficeName='', lockedBagNo='', goDownNo='', houseNo='', winDeliNo='', lotMukimNo='';

            if(resdata.addR_TYP_CODE === '' || resdata.addR_TYP_CODE === undefined || resdata.addR_TYP_CODE === null) {
                if(resdata.addR_FMT_CODE === '' || resdata.addR_FMT_CODE === undefined || resdata.addR_FMT_CODE === null) {
                    addTypeCode = config.addTypeLocal;
                }
                else {
                    addTypeCode = resdata.addR_FMT_CODE;
                }
            }
            else {
                addTypeCode = resdata.addR_TYP_CODE;
            }

            if(resdata.blK_NO === '' || resdata.blK_NO === undefined || resdata.blK_NO === null) {
                blkno = '';
                lockedBagNo = '';
                goDownNo = '';
                winDeliNo = '';
                houseNo = '';
                lotMukimNo = '';
            }
            else {
                if(addTypeCode === config.addTypeMultiStorery){    //H
                    blkno = resdata.blK_NO;
                }
                else if(addTypeCode === config.addTypeLockedBag) { //B
                    lockedBagNo = resdata.blK_NO;
                }
                else if(addTypeCode === config.addTypeGodown) { //G
                    goDownNo = resdata.blK_NO;
                }
                else if(addTypeCode === config.addTypeWindowDeli) { //W
                    winDeliNo =  resdata.blK_NO;
                }
                else if(addTypeCode === config.addTypeHouseShopWalkupApmt) {//S
                    houseNo = resdata.blK_NO;
                }
                else if (addTypeCode === config.addTypeLotMukim) { //L
                    lotMukimNo = resdata.blK_NO;
                }  
            }
    
            if(resdata.bldG_NAME === '' || resdata.bldG_NAME === undefined || resdata.bldG_NAME === null) {
                building = '';
            }
            else {
                if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery || addTypeCode === config.addTypeHouseShopWalkupApmt) {//G,H,S
                    building = resdata.bldG_NAME;
                }
                else if(addTypeCode === config.addTypeLockedBag || addTypeCode === config.addTypePObox || config.addTypeWindowDeli) {//B,P,W
                    postOfficeName = resdata.bldG_NAME;
                }
            }

            if(resdata.poboX_NO === '' || resdata.poboX_NO === undefined || resdata.poboX_NO === null) {
                poBox = '';
            }
            else {
                poBox = resdata.poboX_NO;
            }
    
            if(resdata.sT_NAME === '' || resdata.sT_NAME === undefined || resdata.sT_NAME === null) {
                street = '';
            }
            else {
                if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery 
                ||addTypeCode === config.addTypeHouseShopWalkupApmt || addTypeCode === config.addTypeLotMukim) {//G,H,S,L
                    street = resdata.sT_NAME;
                }
                else {
                    street = '';
                }
            }

            if(resdata.staT_CITY_NAME === '' || resdata.staT_CITY_NAME === undefined || resdata.staT_CITY_NAME === null) {
                stCityName = comdetailsdata.defCountry.label;
            }
            else {
                stCityName = resdata.staT_CITY_NAME;
            }

            if(resdata.uniT_NO === '' || resdata.uniT_NO === undefined || resdata.uniT_NO === null) {
                unitNo = '';
            }
            else if(addTypeCode === config.addTypeGodown || addTypeCode === config.addTypeMultiStorery) {//G,H
                unitNo = resdata.uniT_NO;
            }

            if(resdata.strY_NO === '' || resdata.strY_NO === undefined || resdata.strY_NO === null) {
                storeyNo = '';
            }
            else {
                storeyNo = resdata.strY_NO;
            }

            setMailAddType(addTypeCode) //set as default, Mable TODO: need to change when Henry api up
            
            setMailingAddress({
                isMailAddressSameAsRegisterAddress:'N',
                address_Format_Type: addTypeCode,
                block_Number: blkno,
                street_Name: street,
                storey_Number: storeyNo,
                unit_Number: unitNo,
                building_Name: building,
                postal_Code: postalCode,
                country: addTypeCode !== config.addTypeForeign? comdetailsdata.defCountry.value:config.addTypeForeign,
                country_Desc:addTypeCode !== config.addTypeForeign? comdetailsdata.defCountry.label:'',
                address_Line1:"",
                address_Line2 :"",
                address_Line3 :"",
                state_Citys: stCityName,
                locked_Bag_Number: lockedBagNo,
                godown_Number: goDownNo,
                lot_Mukim_Number:lotMukimNo,
                box_Number: poBox,
                post_Office_Name: postOfficeName,
                house_Number:houseNo,
                window_Delivery_Number: winDeliNo
            })
        })
        .catch(err => {
            console.log('@addressapi err:',err)
            resetMailingAdd();
            setMailAddType(null);
            setIsSearching(false);
            showErrMsg(config.error.GetApiFailed);
        });
       return;
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            props.history.push(config.route.NSPersonDetails);
        }
    }

    const resetMailingAdd = () => {
        setMailingAddress({
            isMailAddressSameAsRegisterAddress: '',
            address_Format_Type: "",
            block_Number: "",
            street_Name: "",
            storey_Number: "",
            unit_Number: "",
            building_Name: "",
            postal_Code: "",
            country: comdetailsdata.defCountry.value,
            country_Desc: comdetailsdata.defCountry.label,
            address_Line1:"",
            address_Line2 :"",
            address_Line3 :"",
            state_City:"",
            locked_Bag_Number: "",
            godown_Number: "",
            lot_Mukim_Number:"",
            box_Number: "",
            post_Office_Name: "",
            house_Number: "",
            window_Delivery_Number: "",
        })
    }

    const handleProceed = () => {
        setButtonPopup(false);
    }

    const handleLatestFYrEndDate = (event) => {
        if(previousYrEndDate) {  // to clear
            setPreviousYrEndDate(null);
        }
        let from = new Date(minDateRange); 
        let to   = new Date(maxDateRange);
        let check = new Date(event.value);

        // console.log(check > from && check < to)
        if(check > from && check < to){
            setflagSucessL(false);
        }else {
            setflagSucessL(true);
        }

        setLatestYrEndDate(event.value);
        
        // set for jan1 -dec 31st defaulted only year validations:
        let yearminus1=new Date(event.value).getFullYear() - 1;
        let setMinDateValue= new Date(new Date(event.value).setFullYear(yearminus1, 0, 1));
        let setMaxDateValue =new Date(new Date(event.value).setFullYear(yearminus1, 11, 31));//dec
 
       setpreviousMaxDate(setMaxDateValue);
       setpreviousMinDate(setMinDateValue);
    }
    
    const handlePreviousFYrEndDate = (event) => {

        let MaxDatefrom = new Date(previousMinDate); 
        let MinDateto   = new Date(previousMaxDate);
        let CurrentDatecheck = new Date(event.value);
 
        if(CurrentDatecheck >= MaxDatefrom && CurrentDatecheck < MinDateto){
            setflagSucessP(false);
        }else {
            setflagSucessP(true);
        }

        setPreviousYrEndDate(event.value);
    }

    const handleAnnualRevenue1 = (e) => {

        const value = e.value;
        setAnnualRevenue1(value);
    }

    const handleAnnualRevenue2 = (e) => {
        const value = e.value;
        setAnnualRevenue2(value);
    }

    const handleProfitLossBeforeTax1 = (e) => {
        const value = e.value;
        setProfitLostBeforeTax1(value);
    }

    const handleProfitLossBeforeTax2 = (e) => {
        const value = e.value;
        setProfitLostBeforeTax2(value);
    }

    const formatDate = (data) => {
        let d = new Date(data), mth = ''+(d.getMonth()+1), day = ''+d.getDate(), yr = d.getFullYear();

        if(mth.length <2) mth ='0'+mth;
        if(day.length < 2) day = '0'+day;

        return [yr, mth, day].join('-');
    } 

    const showAnnualRevenueError = (data) => {
       
        let isShow = false;
        if(data) {
            if(annualRevenueRegex.test(data) === false) {
                isShow = true;
            }
            else {
                isShow = false;
            }
        } 
        return isShow;
    }

    const showProfitLostError = (data) => {
        let isShow = false;
        if(data) {
            if(profitLossRegex.test(data) === false) {
                isShow = true;
            }
            else {
                isShow = false;
            }
        } 
        return isShow;
    }
 
    const isFProductBTL = (res) => {
        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.FinancingProduct === mData.bizFinanceType.Online) { //existing BTL
                result = true;
            }
            else { //Hybrid 0r AIP
                result = false;
            }
        }

        storage.setIsFProdBTL(result?'t':'f');
        // console.log('isFProductBTL: ', result)
        return result;
    }

    const isFProdProperty = (res)=> {
        let result = false;
        const resData = res.Request_Form;
        if(resData) {
            if(resData.Property === 'Y') { //property selected
                result = true;
            }
            else if(resData.FinancingProduct === mData.bizFinanceType.AIP) {
                result = true;
            }
        }

    
        storage.setIsFPTypeProperty(result?'t':'f');

        return result;
    }

    const handleEnterpriseDeclareProceed = (e) => {
        e.preventDefault();
        setShowEnterpriseDeclarePopup(false);
    }

    const getLastSixMonths = () => {
        const months = [];
        const currentDate = new Date();
        for (let i = 1; i < 7; i ++) {
            const date = new Date(currentDate);
            date.setMonth(date.getMonth() - i);
            const monthYear = date.toLocaleString('default',{month:'long',year: 'numeric'})
            months.push(monthYear);
        }

        return months;
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader title={config.Branding.title} img={isFProductBTL(response)?headerImg:isFProdProperty(response)?pStepper:stepper} /><br/>
            <Form
                onSubmitClick={handleSubmit} 
                initialValues={mailingAddress} 
                key={JSON.stringify(mailingAddress)}
                render={(formRenderProps) =>(
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={'ft1'} name={comdetailsdata.formContainerTitle[0].name}/> 

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblRegNo'} leftLabelName={comdetailsdata.label.RegNo}
                                    id={'RegNo'} name={response.CompDtls.Company_UEN !==null? response.CompDtls.Company_UEN:''} />
                              
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCompName'} leftLabelName={comdetailsdata.label.CompName}
                                    id={'CompName'} name={response.CompDtls.Company_Name !==null? response.CompDtls.Company_Name:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCompType'} leftLabelName={comdetailsdata.label.CompType}
                                    id={'lblcompType'} name={response.CompDtls.Entity_Type_Desc !==null? response.CompDtls.Entity_Type_Desc:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblDtOfInc'} leftLabelName={comdetailsdata.label.DtOfInc}
                                    id={'dtOfInc'} name={response.CompDtls.Registration_Date!==null? response.CompDtls.Registration_Date:''} />
                            
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCountryOfInc'} leftLabelName={comdetailsdata.label.CountryOfInc}
                                    id={'countryOfInc'} name={response.CompDtls.Country_of_Incorporation_Desc !==null? response.CompDtls.Country_of_Incorporation_Desc:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblDtOfInc'} leftLabelName={comdetailsdata.label.CompExpDate}
                                    id={'dtOfInc'} name={response.CompDtls.Business_Expiry_Date !==null? response.CompDtls.Business_Expiry_Date:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblPrimaryBiz'} leftLabelName={comdetailsdata.label.primaryBiz} 
                                    id={'PrimaryBizAct'} name={response.CompDtls.Primary_Activity_Desc !==null? response.CompDtls.Primary_Activity_Desc:''} />
                                    
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblSecdBiz'} leftLabelName={comdetailsdata.label.secondBiz}
                                    id={'SecondaryBizAct'} name={response.CompDtls.Secondary_Activity_Desc  !==null? response.CompDtls.Secondary_Activity_Desc:'' } /> 
                            </fieldset>
                        </FormContainer>
                        <FormContainer>
                            <fieldset>
                            <Field component={FormTitleTooltip} 
                                id={'ft2'} name={comdetailsdata.formContainerTitle[1].name}
                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                tooltipTitle={comdetailsdata.tooltipText.ST1} /> 

                               {response.CompDtls.Address_Type_Code === config.addTypeLocal? 
                                <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                                    id={'blk'} name={response.CompDtls.Reg_Add_Block_No !== null? response.CompDtls.Reg_Add_Block_No:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                                    id={'st'} name={response.CompDtls.Reg_Add_Street_Name !==null? response.CompDtls.Reg_Add_Street_Name:''} />
                             
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.FlrNum} 
                                    id={'lvl'} name={response.CompDtls.Reg_Add_Floor_No !==null? response.CompDtls.Reg_Add_Floor_No:''}  />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                                    id={'uno'} name={response.CompDtls.Reg_Add_Unit_No !==null? response.CompDtls.Reg_Add_Unit_No:''}  />
                               
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'bld'} name={response.CompDtls.Reg_Add_Bldg_Name !==null? response.CompDtls.Reg_Add_Bldg_Name:''}  />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                                    id={'ptc'} name={response.CompDtls.Reg_Add_Postal_Code !==null? response.CompDtls.Reg_Add_Postal_Code:''} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'ctry'} name={helper.getCountryDesc('SG',myInfoCountries)}/>
                                </div>
                                :  
                                <div>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine1}
                                    id={'addline1'} name={response.CompDtls.Address_Line_1 !==null? response.CompDtls.Address_Line_1:''}/>

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine2}
                                    id={'addline1'} name={response.CompDtls.Address_Line_2 !==null? response.CompDtls.Address_Line_2:''}/>  
                                </div>
                                 }
                                
                                <CusRadioButton name="SameAsRegBizAddr" leftValue='Y' rightValue='N' disabled={false}
                                    leftValueLabel="Yes" rightValueLabel="No"
                                    label={comdetailsdata.label.SameAsRegBizAddr} labelDesp={comdetailsdata.label.SameAsRegBizAddrDesp}
                                    onChange={handleChange} checkedValue={selectedValue} />

                                <br/>
                            </fieldset>
                        </FormContainer>
                        {selectedValue === 'N' &&
                        <FormContainer>
                            <fieldset>
                            <Field component={FormTitleTooltip} 
                                id={'ft2'} name={comdetailsdata.formContainerTitle[2].name}
                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                tooltipTitle={comdetailsdata.tooltipText.ST2} /> 
                             
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" style={{ marginTop: "5px" }}>{comdetailsdata.label.PostalCode}</div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div style={{width:'90%', float:'left'}}>
                                            <Field className="k-textbox" name={'postal_Code'} id={'postal_Code'}
                                                placeholder={'Please Input'} 
                                                maxLength={6} 
                                                component={FormInput} 
                                                validator={postalCodeValidator} 
                                                onKeyDown={e => {
                                                    if(e.keyCode === 13) {
                                                        e.preventDefault();
                                                        setIsSearching(true);
                                                        let postalCode = formRenderProps.valueGetter('postal_Code');
                                                        resetMailingAdd();
                                                        getAddressbyPostalCode(postalCode);
                                                    }
                                                }}
                                                />
                                        </div>
                                        <div style={{width:'10%', float:'left', textAlign:'center',paddingTop:'5px'}}>
                                            <a className="k-icon k-i-zoom" style={{fontSize:'24px'}} onClick={(e)=>{
                                                e.preventDefault();
                                                setIsSearching(true);
                                                let postCode = formRenderProps.valueGetter('postal_Code');
                                                if(postCode === '' || postCode === undefined) {
                                                    return;
                                                }
                                                else if(postCode.length > 6 || !numericRegex.test(postCode) ) {
                                                    return;
                                                }
                                                resetMailingAdd();
                                                getAddressbyPostalCode(postCode);
                                                }}>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                         
                               {mailAddType !==null &&
                                <div>
                                 {/* check addType Local. If addType is D, then show local*/}
                                 {mailAddType === config.addTypeLocal &&
                                 <div>
                             
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBlock'} leftLabelName={comdetailsdata.label.BlkNo} 
                                    id={'block_Number'} name={'block_Number'} placeholder={'Please input'} 
                                    maxLength={10} validator={blockValidator} /> 
                                
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'Street'} name={'street_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={streetValidator} />
                                
                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputFlrNum'} leftLabelName={comdetailsdata.label.FlrNum} 
                                    id={'storey_Number'} name={'storey_Number'} placeholder={'Please input'} maxLength={3}
                                    validator={levelValidator} />
                                
                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputUno'} leftLabelName={comdetailsdata.label.UnitNo} 
                                    id={'UnitNo'} name={'unit_Number'}  placeholder={'Please input'} maxLength={6} 
                                    validator={unitNoValidator} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblInputBld'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'BldName'} name={'building_Name'}  placeholder={'Please input'} maxLength={66} 
                                    validator={buildingValidator} />
                                
                                <Field component={CusFormInput} 
                                    leftLabelId={'lblCountry'} leftLabelName={comdetailsdata.label.Country} 
                                    id={'Country'} name={'country_Desc'} disabled={true} />
                                </div>}
                                {/* check addType Foreign. If addType is F, then show*/}
                                {mailAddType === config.addTypeForeign &&
                                <div>
                                 
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputAddLine1'} leftLabelName={comdetailsdata.label.AddLine1} 
                                    id={'AddLine1'} name={'address_Line1'} placeholder={'Please input'} 
                                    maxLength={66} validator={addressValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputAddLine2'} leftLabelName={comdetailsdata.label.AddLine2} 
                                    id={'AddLine2'} name={'address_Line2'} placeholder={'Please input'} 
                                    maxLength={66} validator={addressValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputAddLine3'} leftLabelName={comdetailsdata.label.AddLine3} 
                                    id={'AddLine3'} name={'address_Line3'} placeholder={'Please input'} 
                                    maxLength={66} validator={addressValidator} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'fState'} name={mailingAddress.state_City} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'ctry'} name={mailingAddress.country_Desc}/>
                                </div>}

                                {/* check addType Locked Bag Address. If addType is B, then show*/}
                                {mailAddType === config.addTypeLockedBag &&
                                <div>
                          
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputPostOffice'} leftLabelName={comdetailsdata.label.PostOffice} 
                                    id={'post_Office_Name'} name={'post_Office_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={postOfficeValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputLockedBagNo'} leftLabelName={comdetailsdata.label.LockedBagNo} 
                                    id={'LockedBagNo'} name={'locked_Bag_Number'} placeholder={'Please input'} 
                                    maxLength={10} validator={lockBagValidator} />
                                <br/>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'lState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'lctry'} name={'SINGAPORE'}/>
                                </div>}

                                {/* check addType Godown Address. If addType is G, then show*/}
                                {mailAddType === config.addTypeGodown &&
                                <div>
                               
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBldName'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'gBldName'} name={'building_Name'} placeholder={'Please input'} 
                                    maxLength={66} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStoreyNo'} leftLabelName={comdetailsdata.label.StoreyNo} 
                                    id={'gStoreyNo'} name={'storey_Number'} placeholder={'Please input'} 
                                    maxLength={3} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputUnitNo'} leftLabelName={comdetailsdata.label.UnitNo} 
                                    id={'gUnitNo'} name={'unit_Number'} placeholder={'Please input'} 
                                    maxLength={6}  />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'gStreet'} name={'street_Name'} placeholder={'Please input'} 
                                    maxLength={66}  />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputGodownNo'} leftLabelName={comdetailsdata.label.GodownNo} 
                                    id={'GodownNo'} name={'godown_Number'} placeholder={'Please input'} 
                                    maxLength={6}  />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'gState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'gctry'} name={'SINGAPORE'}/>
                                </div>}

                                {/* check addType Multi-Storery Address. If addType is H, then show*/}
                                {mailAddType === config.addTypeMultiStorery &&
                                <div>
                      
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                                    id={'mBlkNo'} name={'block_Number'} placeholder={'Please input'} 
                                    maxLength={6} validator={blockValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBldName'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'mBldName'} name={'building_Name'} placeholder={'Please input'} 
                                    maxLength={66} />
                                
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStoreyNo'} leftLabelName={comdetailsdata.label.StoreyNo} 
                                    id={'mStoreyNo'} name={'storey_Number'} placeholder={'Please input'} 
                                    maxLength={3} validator={storeyValidator} />

                                
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputUnitNo'} leftLabelName={comdetailsdata.label.UnitNo} 
                                    id={'mUnitNo'} name={'unit_Number'} placeholder={'Please input'} 
                                    maxLength={6} validator={unitNoValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'mStreet'} name={'street_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={streetValidator} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'mState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'mctry'} name={'SINGAPORE'}/>
                                </div>}

                                {/* check addType Lot / Mukim Address. If addType is L, then show*/}
                                {mailAddType === config.addTypeLotMukim &&
                                <div>
                             
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'lStreet'} name={'street_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={streetValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputLot_Mukim_Number'} leftLabelName={comdetailsdata.label.LotMukimNo} 
                                    id={'lot_Mukim_Number'} name={'lot_Mukim_Number'} placeholder={'Please input'} 
                                    maxLength={6} validator={lotMukimValidator} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'lotState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'lotctry'} name={'SINGAPORE'}/>
                                </div>}

                                {/* check addType P.O. Box Address. If addType is P, then show*/}
                                {mailAddType === config.addTypePObox &&
                                <div>
                  
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.BoxNo} 
                                    id={'BoxNo'} name={'box_Number'} placeholder={'Please input'} 
                                    maxLength={10} validator={boxNoValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputPostOffice'} leftLabelName={comdetailsdata.label.PostOffice} 
                                    id={'post_Office_Name'} name={'post_Office_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={postOfficeValidator} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'pState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'pctry'} name={'SINGAPORE'}/>
                                </div>}

                                {/* check addType House, Shop , Walkup Apartment. If addType is S, then show*/}
                                {mailAddType === config.addTypeHouseShopWalkupApmt &&
                                <div>
                          
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputBldName'} leftLabelName={comdetailsdata.label.BldName} 
                                    id={'hswBldName'} name={'building_Name'} placeholder={'Please input'} 
                                    maxLength={66}   />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputHouseNo'} leftLabelName={comdetailsdata.label.HouseNo} 
                                    id={'HouseNo'} name={'house_Number'} placeholder={'Please input'} 
                                    maxLength={6} validator={houseNoValidator} />
                                
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputStreet'} leftLabelName={comdetailsdata.label.Street} 
                                    id={'lStreet'} name={'street_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={streetValidator} />
                                <br/>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'hState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'hctry'} name={'SINGAPORE'}/>
                                </div> }

                                {/* check addType Window Delivery Address. If addType is W, then show*/}
                                {mailAddType === config.addTypeWindowDeli &&
                                <div>
                         
                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputWinDeliNo'} leftLabelName={comdetailsdata.label.WinDeliNo} 
                                    id={'WinDeliNo'} name={'window_Delivery_Number'} placeholder={'Please input'} 
                                    maxLength={6} validator={winDeliValidator} />

                                <Field component={CusFormInput2} 
                                    leftLabelId={'lblInputPostOffice'} leftLabelName={comdetailsdata.label.PostOffice} 
                                    id={'post_Office_Name'} name={'post_Office_Name'} placeholder={'Please input'} 
                                    maxLength={66} validator={postOfficeValidator} />
                                <br/>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblState'} leftLabelName={comdetailsdata.label.State}
                                    id={'wState'} name={'SINGAPORE'} />

                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                                    id={'wctry'} name={'SINGAPORE'}/>
                                </div>}
                                </div>
                                }
                               
                            </fieldset>
                            <br/>
                        </FormContainer>
                        }
                        <FormContainer>
                            <fieldset>
                            <Field component={FormTitleTooltip} 
                                id={'ft3'} name={comdetailsdata.formContainerTitle[3].name}
                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                tooltipTitle={comdetailsdata.tooltipText.ST3} /> 

                                <div style={{paddingTop:'10px',paddingBottom:'20px'}}>
                                    <div>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div id={'lbllatestFinancialYearEndDate'} style={{ marginTop: "5px" }}>
                                                    {comdetailsdata.label.latestFinancialYrEndDate}
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className='dt-pk'>
                                                    {/* <DateInput 
                                                        placeholder="dd-mm-yyyy" 
                                                        format="dd-MM-yyyy"
                                                        formatPlaceholder="formatPattern"
                                                        value={latestYrEndDate} 
                                                        min={minDateRange} 
                                                        max={maxDateRange} 
                                                        onChange={handleLatestFYrEndDate} 
                                                    /> */}
                                                    <DatePicker 
                                                        placeholder="dd-mm-yyyy" 
                                                        format="dd-MM-yyyy"
                                                        formatPlaceholder="formatPattern"
                                                        value={latestYrEndDate} 
                                                        min={minDateRange} 
                                                        max={maxDateRange} 
                                                        onChange={handleLatestFYrEndDate} 
                                                    /> 
                                                    {
                                                     (latestYrEndDate === null) &&
                                                        <Error id={'err1'} style={{paddingLeft:'15px'}}>
                                                            {comdetailsdata.errMsg.invalidLatestYrEnd}
                                                        </Error>
                                                     }
                                               
                                                    {flagSucessL &&  <Error id={'err4'} style={{paddingLeft:'15px'}}>
                                                        {"Latest financial information must be within 2 years from application date."}
                                                     </Error>}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div style={{width:'100%',marginTop: "5px"}} id={'lblcompanyrevenue1'}>
                                                    <div style={{width:'90%',float:'left'}}>
                                                        {comdetailsdata.label.annualRevenue}
                                                    </div>
                                                    <div style={{width:'10%',float:'right'}}>
                                                        {'S$'}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="box">
                                                    <NumericTextBox 
                                                        id={'annualRevenue1'}
                                                        name={'annualRevenue1'}
                                                        placeholder={'Please input'} 
                                                        format="n2"
                                                        value = {annualRevenue1}
                                                        spinners={false} 
                                                        onChange= {handleAnnualRevenue1}
                                                        // required={true}
                                                        // validationMessage=' '
                                                    />
                                                    {
                                                     (showAnnualRevenueError(annualRevenue1)) &&
                                                        <Error id={'errAnnRev1'}>
                                                            {comdetailsdata.errMsg.numericOnly}
                                                        </Error>
                                                     }
                                                </div>
                                             </div>
                                        </div>
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div id={'lblprofitLost1'} style={{width:'100%',marginTop: "5px"}}>
                                                    <div style={{width:'90%',float:'left'}}>
                                                        <div style={{float:'left'}}>
                                                            {comdetailsdata.label.profitLossBeforeTax}
                                                            &nbsp; &nbsp;
                                                        </div>
                                                        <div style={{float:'left'}}>
                                                            <Tooltip position={'right'} anchorElement={'target'}>
                                                                <span className="k-icon k-i-information" title={comdetailsdata.tooltipText.profitLossBeforeTaxTT}></span> 
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                    <div style={{width:'10%',float:'right'}}>
                                                        {'S$'}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <div className="box">
                                                        <NumericTextBox 
                                                            spinners={false} 
                                                            format="n2" 
                                                            id={'profitOrLossBeforeTax1'}
                                                            name={'profitOrLossBeforeTax1'}
                                                            placeholder={'Please input'} 
                                                            value = {profitLostBeforeTax1}
                                                            onChange= {handleProfitLossBeforeTax1}
                                                            // required={true}
                                                            // validationMessage=' '
                                                        />
                                                        {
                                                        (showProfitLostError(profitLostBeforeTax1)) &&
                                                            <Error id={'errProfitLoss1'}>
                                                                {comdetailsdata.errMsg.numericOnly}
                                                            </Error>
                                                        }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {isFProductBTL(response) &&
                                    <>
                                    {showAddBtn ? 
                                    <div>
                                    {!isPrevFinanceFieldsMandatory &&
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span  
                                                onClick={ e => {
                                                    e.preventDefault();
                                                    if(latestYrEndDate === '' || latestYrEndDate === null || latestYrEndDate === undefined) {
                                                        showErrMsg(comdetailsdata.errMsg.invalidLatestYrEnd)
                                                    }
                                                    else if(annualRevenue1 === '' || annualRevenue1 === null || annualRevenue1 === undefined) {
                                                        showErrMsg(comdetailsdata.errMsg.emptyAnnualRevenue)
                                                    }
                                                    else if(profitLostBeforeTax1 === '' || profitLostBeforeTax1 === null || profitLostBeforeTax1 === undefined) {
                                                        showErrMsg(comdetailsdata.errMsg.emptyProfitLoss)
                                                    }
                                                    else {
                                                        setShowAddBtn(false); //hide show btn
                                                    }
                                                }}>
                                                <span className="k-icon k-i-plus-outline" style={{fontSize:'24px', marginRight:'5px', color:'grey'}}>
                                                </span>
                                                <label>{comdetailsdata.label.addMoreBtn}</label>
                                            </span>
                                        </div>
                                        </div>}
                                    </div>
                                    :
                                    <div>
                                        {!isPrevFinanceFieldsMandatory &&
                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <div className="box text-right" 
                                                    onClick={ e => {
                                                        e.preventDefault();
                                                        setShowAddBtn(true); //hide show btn
                                                        setPreviousYrEndDate();
                                                        setAnnualRevenue2('');
                                                        setProfitLostBeforeTax2('');
                                                }}>
                                                    <label style={{marginRight:'10px'}}>REMOVE</label>
                                                    <span className="k-icon k-i-delete" style={{fontSize:'24px', color:'grey'}}></span>
                                                </div>
                                            </div>
                                        </div>}
                                        {isFProductBTL(response) &&
                                        <div>
                                            <div className="row around-xs inputPair elementVisible">
                                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div id={'lblprevFinancialYrEndDate'} style={{ marginTop: "5px" }}>
                                                        {comdetailsdata.label.prevFinancialYrEndDate}
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div className='dt-pk'>
                                                        {/* <DateInput 
                                                            placeholder="dd-mm-yyyy" 
                                                            format="dd-MM-yyyy"
                                                            formatPlaceholder="formatPattern"
                                                            value={previousYrEndDate} 
                                                            onChange={handlePreviousFYrEndDate} 
                                                            min={previousMinDate} 
                                                            max={previousMaxDate}
                                                            // required={true}
                                                            /> */}
                                                        <DatePicker 
                                                            placeholder="dd-mm-yyyy" 
                                                            format="dd-MM-yyyy"
                                                            formatPlaceholder="formatPattern"
                                                            value={previousYrEndDate}
                                                            min={previousMinDate} 
                                                            max={previousMaxDate}
                                                            onChange={handlePreviousFYrEndDate} 
                                                            /> 
                                                        
                                                        {
                                                        (previousYrEndDate === null)&&
                                                            <Error id={'err2'} style={{paddingLeft:'15px'}}>
                                                                {comdetailsdata.errMsg.invalidPrevYrEnd}
                                                            </Error>
                                                        }
                                      
                                                        {flagStatusP &&  <Error id={'err5'} style={{paddingLeft:'15px'}}>
                                                            {"Previous financial year end date must be within 1 year from latest financial year end date"}
                                                            </Error>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row around-xs inputPair elementVisible">
                                                <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div style={{width:'100%',marginTop: "5px"}} id={'lblcompanyrevenue2'}>
                                                        <div style={{width:'90%',float:'left'}}>
                                                            {comdetailsdata.label.annualRevenue}
                                                        </div>
                                                        <div style={{width:'10%',float:'right'}}>
                                                            {'S$'}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div className="box">
                                                    <NumericTextBox 
                                                        spinners={false} 
                                                        format="n2"
                                                        id={'annualRevenue2'}
                                                        name={'annualRevenue2'}
                                                        placeholder={'Please input'} 
                                                        value = {annualRevenue2}
                                                        onChange= {handleAnnualRevenue2}
                                                        // required={true}
                                                        // validationMessage=' '
                                                    />
                                                    {
                                                     (showAnnualRevenueError(annualRevenue2)) &&
                                                        <Error id={'errAnnRev2'}>
                                                            {annualRevenue2===''?comdetailsdata.errMsg.emptyAnnualRevenue:comdetailsdata.errMsg.numericOnly}
                                                        </Error>
                                                     }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row around-xs inputPair elementVisible">
                                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div id={'lblprofitLost2'} style={{width:'100%',marginTop: "5px"}}>
                                                        <div style={{width:'90%',float:'left'}}>
                                                            <div style={{float:'left'}}>
                                                                {comdetailsdata.label.profitLossBeforeTax}
                                                                &nbsp; &nbsp;
                                                            </div>
                                                            <div style={{float:'left'}}>
                                                                <Tooltip position={'right'} anchorElement={'target'}>
                                                                    <span className="k-icon k-i-information" title={comdetailsdata.tooltipText.profitLossBeforeTaxTT}></span> 
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div style={{width:'10%',float:'right'}}>
                                                            {'S$'}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                    <div className="box">
                                                        <NumericTextBox 
                                                            spinners={false} 
                                                            format="n2" 
                                                            id={'profitOrLossBeforeTax2'}
                                                            name={'profitOrLossBeforeTax2'}
                                                            placeholder={'Please input'} 
                                                            value = {profitLostBeforeTax2}
                                                            onChange= {handleProfitLossBeforeTax2}
                                                            // required={true}
                                                            // validationMessage=' '
                                                        />
                                                        {
                                                        (showProfitLostError(profitLostBeforeTax2)) &&
                                                            <Error id={'errProfitLoss2'}>
                                                                {profitLostBeforeTax2===''?comdetailsdata.errMsg.emptyProfitLoss:comdetailsdata.errMsg.numericOnly}
                                                            </Error>
                                                        }
                                                     </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    }
                                    </>
                                }
                                </div>
                            </fieldset>
                        </FormContainer>

                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={'ft1'} name={comdetailsdata.formContainerTitle[4].name}/> 
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblIssuedCapAmt'} leftLabelName={comdetailsdata.label.issuedCapAmt}
                                    id={'issuedCapAmt'} name={response.CompDtls.Capital_IssuedAmount !== '0.00'? response.CompDtls.Capital_IssuedAmount:'Not Applicable'}/>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblBizFormerName'} leftLabelName={comdetailsdata.label.bizFormerName}
                                    id={'bizFormerName'} name={response.CompDtls.Business_Former_Name !== null? response.CompDtls.Business_Former_Name:'Not Applicable'}/>
                                {/* {(storage.getIsFProdBTL() === 'f')&&
                                <FieldWrapper>
                                    <BlueboxIconTxt />
                                </FieldWrapper>
                                } */}
                            </fieldset>
                            <br/>
                        </FormContainer>

                        <FormContainer>
                            <div style={{paddingTop:'20px',paddingBottom:'20px'}}>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <Button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</Button>                                                     
                                    </div>
                                </div>                            
                            </div>
                        </FormContainer>  
                        <br/>
                    </FormElement>
                )}>
            </Form>
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
            {/* {isSearching && <Loading />} */}
            {/* <CusNotification trigger={isError}  msg={errMsg} setTrigger={setIsError} closable={true} /> */}
            <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                <div style={{ textAlign: "left", width:'100%' }}>
                    <div className="bgBlack fbaPSize">
                        <div className="row">
                            <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                <div className="dcPgmh">{comdetailsdata.wclPopup.header}</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="fbaPSize" style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap',paddingBottom:'10px',paddingTop:'10px', fontSize: "small"}}>                        
                    <Checkbox defaultChecked={isChecked} label={comdetailsdata.wclPopup.cbdata} onChange={handleChkChange} />                                
                </div>
                {comdetailsdata.wclPopup.declareList.map((item, idx) => (
                    <div key={idx}>
                        <div style={{textAlign: "left", display: 'flex', flexWrap: 'wrap',color:'#000000'}}>
                            <ol style={{listStyle: "disc", marginBottom: "0",fontSize: "small"}}> 
                                <li>{item.lblname}</li>
                            </ol>
                        </div>
                    </div>
                ))}
                <br/>
                <div className="row">
                    <div className="col-6" style={{ textAlign: "left"}}>                        
                        <Button look="outline" className="btSize1" onClick={() => setButtonPopup(false)}>Back</Button>
                    </div> 
                    <div className="col-6" style={{ textAlign: "right"}}> 
                        <Button primary={true} className="btSize1 sccbTxt2 btRht greenbt" onClick={handleProceed} disabled={!isChecked}>Proceed</Button>
                    </div>
                </div> 
            </Popup>
            <EnterpriseDeclarePopup popupValue={showEnterpriseDeclarePopup} setPopupValue={setShowEnterpriseDeclarePopup} 
                onClickProceed={handleEnterpriseDeclareProceed}/>
            <LoadingText show={isSearching} setShow={setIsSearching} label={'Please wait..'} />
            {isSaving && <Loading />}
        </div>
    )
}

export default CompanyDetails;

